import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import {
    ReactPlugin,
    withAITracking
} from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();
const isAppInsightsEnabled =
    process.env.NODE_ENV === 'production' &&
    Boolean(process.env.REACT_APP_APPINSIGHTS_KEY);

const ai = isAppInsightsEnabled
    ? new ApplicationInsights({
        config: {
            instrumentationKey: process.env.REACT_APP_APPINSIGHTS_KEY,
            extensions: [reactPlugin],
            enableAutoRouteTracking: true,
            disableFetchTracking: true,
            disableAjaxTracking: true,
        }
    })
    : null;

if (ai) {
    ai.loadAppInsights();
}

const withAppInsightsTracking = Component => withAITracking(reactPlugin, Component);

export default withAppInsightsTracking;
export const appInsights = ai?.appInsights || null;
export const appInsightsEnabled = isAppInsightsEnabled;
export { reactPlugin };
